var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { id: "Icon/Fill/edit-2" } }, [
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "alpha" },
            attrs: {
              id: _vm.maskId,
              maskUnits: "userSpaceOnUse",
              x: "3",
              y: "2",
              width: "17",
              height: "20"
            }
          },
          [
            _c("path", {
              attrs: {
                id: "Mask_2",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d:
                  "M17.9655 6.72867L15.2715 4.03467L13.3235 5.98367L16.0185 8.67867L17.9655 6.72867ZM5.0905 17.9957C5.0605 17.9987 5.0305 17.9997 5.0005 17.9997C4.7365 17.9997 4.4815 17.8957 4.2925 17.7067C4.0835 17.4967 3.9775 17.2047 4.0035 16.9097L4.3825 12.7397C4.4245 12.2827 4.6265 11.8507 4.9525 11.5257L13.9485 2.52967C14.6505 1.82467 15.9235 1.85967 16.6645 2.59867L19.4025 5.33667L19.4035 5.33767C20.1685 6.10367 20.1995 7.32167 19.4715 8.05167L10.4745 17.0487C10.1495 17.3737 9.7185 17.5757 9.2605 17.6177L5.0905 17.9957ZM5 20H19C19.55 20 20 20.45 20 21C20 21.55 19.55 22 19 22H5C4.45 22 4 21.55 4 21C4 20.45 4.45 20 5 20Z",
                fill: "white"
              }
            })
          ]
        ),
        _c("g", { attrs: { mask: "url(#" + _vm.maskId + ")" } }, [
          _c("g", { attrs: { id: "🎨 Color" } }, [
            _c("rect", {
              attrs: { id: "Base", width: "24", height: "24", fill: _vm.color }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }